var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobe3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "globe"
  }, /*#__PURE__*/React.createElement("line", {
    id: "c",
    "data-name": "Line 74",
    x1: 10.5,
    y1: 0.5,
    x2: 10.5,
    y2: 20.5,
    fill: "none",
    stroke: "#696969"
  }), /*#__PURE__*/React.createElement("line", {
    id: "d",
    "data-name": "Line 75",
    x1: 0.5,
    y1: 10.5,
    x2: 20.5,
    y2: 10.5,
    fill: "none",
    stroke: "#696969"
  }), /*#__PURE__*/React.createElement("line", {
    id: "e",
    "data-name": "Line 76",
    x1: 1.76,
    y1: 5.75,
    x2: 19.55,
    y2: 5.75,
    fill: "none",
    stroke: "#696969"
  }), /*#__PURE__*/React.createElement("line", {
    id: "f",
    "data-name": "Line 77",
    x1: 1.76,
    y1: 15.56,
    x2: 19.55,
    y2: 15.56,
    fill: "none",
    stroke: "#696969"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "g",
    "data-name": "Ellipse 93",
    cx: 10.66,
    cy: 10.66,
    rx: 5.76,
    ry: 10.16,
    fill: "none",
    stroke: "#696969",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "h",
    "data-name": "Ellipse 94",
    cx: 10.5,
    cy: 10.5,
    r: 10,
    fill: "none",
    stroke: "#696969",
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe3);
export default __webpack_public_path__ + "static/media/globe_3.d55b56d962cb1ddbc661c999ecf08d21.svg";
export { ForwardRef as ReactComponent };